// The external tech-manual library techs pull PDFs from.
//
// The site is login-gated: the tech (or an admin) signs in once per device in
// their own browser, and the browser remembers the session. We NEVER store the
// site's credentials — a downloaded manual comes back into the app through the
// normal document Upload flow, where it's AI-extracted and reused on every
// future job for that model. If the URL ever moves, change it here.
export const MANUAL_LIBRARY = {
  name: 'Service Alliance Group',
  url: 'https://servicealliancegroup.com/member-dashboard/tech-manuals/',
};
